import { Space } from 'component/Space'
import { Spinner } from 'component/Spinner'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { ItemsList } from 'page/catalog/Content/ItemsList'
import { DemoCatalogFilters } from 'page/catalog/DemoCatalogFilters/DemoCatalogFilters'
import { MoreBottom } from 'page/catalog/Pagination/MoreBottom'
import { PaginationBottom } from 'page/catalog/Pagination/PaginationBottom'
import { PaginationTop } from 'page/catalog/Pagination/PaginationTop'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { ui } from 'store/home/ui/HomeUiStore'
import css from './Content.module.scss'

export const Content = observer(() => {
  const { small } = ui.window
  const demo = useDemo()
  const { stand, items } = demo
  const empty = !items.length
  const { busy, reloading, error, search, count } = demo.form
  const pagination = count > 20
  const height = small ? 400 : 800

  return <>
    <Vertical className={css.content}>
      <Vertical gap={8}>
        <PaginationTop />
        <DemoCatalogFilters />
      </Vertical>
      <Space>
        {empty && <Space height={height} wide center>
          {!busy && <Typo size={14} secondary error={error}>
            {error ? i18n('Error') : search ? i18n('demo.NotingFound') : i18n('demo.NoItems')}
          </Typo>}
        </Space>}
        {!empty && <ItemsList />}
        {reloading && <Space height={height} pin={[0, 0, null, 0]} center>
          <Spinner />
        </Space>}
      </Space>
      {stand ? <MoreBottom /> : pagination ? <PaginationBottom /> : <Space height={16} />}
    </Vertical>
  </>
})
